import { LeaveCondition } from '@Managers/StateMachine/LeaveCondition';
import { EWildWheelFeatureStates } from './WildWheelFeatureStates';

export type TWildWheelFeatureStateConditionsNames =
    | 'hiddenCondition'
    | 'startCondition'
    | 'spinCondition'
    | 'resultCondition'
    | 'endCondition'
    | 'mergeStartCondition'
    | 'mergeEndCondition';

export const WildWheelFeatureStateConditions: { [K in TWildWheelFeatureStateConditionsNames]: LeaveCondition<EWildWheelFeatureStates> } = {
    hiddenCondition: new LeaveCondition('waitForWildWheelState', EWildWheelFeatureStates.WILD_WHEEL_HIDDEN),
    startCondition: new LeaveCondition('waitForStartAnimationFinishOrSkip', EWildWheelFeatureStates.WILD_WHEEL_START),
    spinCondition: new LeaveCondition('waitForSpinAnimationFinishOrSkip', EWildWheelFeatureStates.WILD_WHEEL_SPIN),
    resultCondition: new LeaveCondition('waitForResultAnimationFinishOrSkip', EWildWheelFeatureStates.WILD_WHEEL_RESULT),
    endCondition: new LeaveCondition('waitForEndAnimationFinishOrSkip', EWildWheelFeatureStates.WILD_WHEEL_END),
    mergeStartCondition: new LeaveCondition('waitForMergeStartAnimationFinishOrSkip', EWildWheelFeatureStates.WILD_WHEEL_MERGE_START),
    mergeEndCondition: new LeaveCondition('waitForMergeEndAnimationFinishOrSkip', EWildWheelFeatureStates.WILD_WHEEL_MERGE_END)
};
